import { withNamespaces } from "react-i18next";
import Accordion from 'react-bootstrap/Accordion';
import PaperImage from "src/modules/3rd-party-management/assets/images/paper.svg";
import { Table } from "reactstrap";
import DateUtils from "src/services/utils/DateUtils";
import { INTERNATIONAL_DATE_FORMAT } from 'src/common/constants';
import {
    hasNonEmptyArray,
    parseHandelsregisterOrganizationData
} from "../../helpers";

const AnnualStatements = ({
    t,
    activeAccordion,
    setActiveAccordion,
    detailsQuery
}) => {
    const dateUtils = new DateUtils();
    const data = parseHandelsregisterOrganizationData(detailsQuery?.data?.company);
    const rows = data?.annual_financial_statements || [];

    if (!hasNonEmptyArray(rows)) {
        return null;
    }

    return (
        <Accordion.Item
            onClick={() => setActiveAccordion('annual-statements')}
            className={activeAccordion === 'annual-statements' ? 'active' : ''}
            eventKey={'annual-statements'}
        >
            <Accordion.Header>
                <img src={PaperImage} alt="" />
                <span>{t('Annual Financial Statements')}</span>
            </Accordion.Header>

            <Accordion.Body>
                <div className="table-responsive mb-3">
                    <Table bordered hover striped size="sm" className="mb-0">
                        <thead>
                            <tr>
                                <th>{t('Year')}</th>
                                <th>{t('Title')}</th>
                                <th>{t('Type')}</th>
                                <th>{t('Date')}</th>
                                <th>{t('Language')}</th>
                            </tr>
                        </thead>
                        <tbody>
                            {rows.map((row, index) => (
                                <tr key={`${row.year}-${index}`}>
                                    <td>{row.year || '-'}</td>
                                    <td>{row.document_title || '-'}</td>
                                    <td>{row.document_type || '-'}</td>
                                    <td>
                                        {row.document_date
                                            ? dateUtils.convertDateToDate(row.document_date, INTERNATIONAL_DATE_FORMAT)
                                            : '-'}
                                    </td>
                                    <td>{row.language || '-'}</td>
                                </tr>
                            ))}
                        </tbody>
                    </Table>
                </div>

                {rows.filter((r) => r.document_md).slice(0, 3).map((row, index) => (
                    <div key={`md-${row.year || index}`} className="mb-4">
                        <h6 className="mb-2">
                            {row.document_title || `${t('Year')} ${row.year || ''}`}
                        </h6>
                        <pre
                            className="bg-light p-3 rounded"
                            style={{
                                maxHeight: 320,
                                overflow: 'auto',
                                whiteSpace: 'pre-wrap',
                                fontSize: 12
                            }}
                        >
                            {row.document_md}
                        </pre>
                    </div>
                ))}
            </Accordion.Body>
        </Accordion.Item>
    );
};

export default withNamespaces()(AnnualStatements);
